exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown:nth-child(2) {\n  margin-top: 3rem;\n}", ""]);

// exports
